// esta libreria solo esta en Catalogo Web para poder compartir codigo con la App de Ferias
// solo tiene lo necesario para que compile y funcione el Catálogo Web

var oglobales; //NO USAR DESDE FUERA DE ESTA JS. En su lugar utilizar GetObjGlobales()

function GetObjGlobales()
{
    if (oglobales == undefined)
    {
        oglobales = new ObjGlobales();
    }
    return oglobales;
}

function ObjGlobales()
{

};
ObjGlobales.prototype = {
    //* variables version nativa *//
    offline: 'N',
    modoConexion: '',
    so: '', //sistema operativo
    wsListaExpositoresPath: "../wsListaExpositores.svc/",

    EsOffline: function ()
    {
        if (this.offline == 'S')
            return true
        else
            return false;
    },

    getFeria: function ()
    {
        return GetObjConfiguracion().feria;
    },
    EsSpanish: function () {
        if (GetObjConfiguracion().idio == 'es')
            return true;
        else
            return false;
    }

}
